requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xQuickView', {
      sectionId: window.xQuickView.sectionId,
      enabled: window.xQuickView.enabled,
      buttonLabel: window.xQuickView.buttonLabel,
      show_atc_button: window.xQuickView.show_atc_button,
      btn_atc_bottom: window.xQuickView.atc_btn_bottom,
      atc_btn_image_desktop: window.xQuickView.atc_btn_image_desktop,
      show: false,
      loading: false,
      currentVariant: '',
      cachedResults: [],
      cachedfetch: [],
      loadingUrls: [],
      loadedChooseOptions: [],
      loadedChooseOptionsID: [],
      selected: false,
      loadingChooseOption: false,
      showMiniCartChooseOption: false,
      loadingMiniCartChooseOption: false,
      loadedMiniCartChooseOptions: [],
      miniCartPriceObserver: null,
      miniCartVariantUpdateHandler: null,
      miniCartProductBaseUrl: '',
      miniCartModalBaseTitle: '',
      isMiniCart: false,
      buttonQuickView: '',
      addListener() {
        document.addEventListener('eurus:cart:items-changed', () => {
          this.cachedResults = [];
          this.loadedMiniCartChooseOptions = [];
        });
      },
      normalizeProductUrl(url) {
        const cleanUrl = (url || '').replace(/\s+/g, '');
        const path = cleanUrl.split('?')[0];
        const collectionProductMatch = path.match(
          /\/collections\/[^/]+\/products\/(.+)$/
        );

        if (collectionProductMatch) {
          return `/products/${collectionProductMatch[1]}`;
        }

        return path;
      },
      buildChooseOptionUrl(url, page = 1) {
        const baseUrl = this.normalizeProductUrl(url);
        const pageNum = page || 1;
        return `${baseUrl}?section_id=choose-option&page=${pageNum}`;
      },
      prepareMiniCartChooseOptionContent(container) {
        if (!container) return;

        const addToCartBtn = container.querySelector('.add_to_cart_button');
        const iconAddToCartBtn = container.querySelector(
          '.label-btn-quickview'
        );

        if (addToCartBtn) addToCartBtn.style.display = 'block';
        if (iconAddToCartBtn) iconAddToCartBtn.style.display = 'none';

        this.bindMiniCartChooseOptionSummarySync(container);
        this.initMiniCartPaymentButtons();
      },
      updateMiniCartSummaryLinks(productUrl, variantId) {
        const imageLink = document.getElementById(
          'mini-cart-choose-options-image-link'
        );
        const titleLink = document.getElementById(
          'mini-cart-choose-options-title-link'
        );
        const baseUrl = (productUrl || this.miniCartProductBaseUrl || '').split(
          '?'
        )[0];

        if (!baseUrl) return;

        const href = variantId ? `${baseUrl}?variant=${variantId}` : baseUrl;

        if (imageLink) imageLink.href = href;
        if (titleLink) titleLink.href = href;
      },
      initMiniCartPaymentButtons() {
        if (
          window.Shopify &&
          Shopify.PaymentButton &&
          typeof Shopify.PaymentButton.init === 'function'
        ) {
          Shopify.PaymentButton.init();
        }
      },
      setMiniCartChooseOptionSummary(el) {
        const summary = document.getElementById(
          'mini-cart-choose-options-summary'
        );
        const image = document.getElementById('mini-cart-choose-options-image');
        const vendor = document.getElementById(
          'mini-cart-choose-options-vendor'
        );
        const title = document.getElementById('mini-cart-choose-options-title');
        const price = document.getElementById('mini-cart-choose-options-price');

        if (!summary) return;

        if (!el) {
          summary.classList.add('hidden');
          this.miniCartProductBaseUrl = '';
          this.miniCartModalBaseTitle = '';
          return;
        }

        const imageSrc = el.dataset.miniCartModalImage || '';
        const vendorText = el.dataset.miniCartModalVendor || '';
        const titleText = el.dataset.miniCartModalTitle || '';
        const priceHtml = el.dataset.miniCartModalPriceHtml || '';
        const productUrl = el.dataset.miniCartModalProductUrl || '';
        const baseTitle = el.dataset.miniCartModalBaseTitle || titleText;

        this.miniCartProductBaseUrl = productUrl.split('?')[0];
        this.miniCartModalBaseTitle = baseTitle;

        if (image) {
          image.src = imageSrc;
          image.alt = titleText;
        }

        if (vendor) {
          vendor.textContent = vendorText;
          vendor.classList.toggle('hidden', !vendorText);
        }

        if (title) {
          title.textContent = titleText;
        }

        if (price) {
          price.innerHTML = priceHtml;
        }

        const variantMatch = productUrl.match(/[?&]variant=(\d+)/);
        this.updateMiniCartSummaryLinks(
          productUrl,
          variantMatch ? variantMatch[1] : ''
        );

        summary.classList.remove('hidden');
      },
      bindMiniCartChooseOptionSummarySync(container) {
        if (this.miniCartPriceObserver) {
          this.miniCartPriceObserver.disconnect();
          this.miniCartPriceObserver = null;
        }

        if (this.miniCartVariantUpdateHandler) {
          document.removeEventListener(
            this.miniCartVariantUpdateHandler.eventName,
            this.miniCartVariantUpdateHandler.handler
          );
          this.miniCartVariantUpdateHandler = null;
        }

        const contentPrice = container.querySelector('[id^="price-"]');
        const summaryPrice = document.getElementById(
          'mini-cart-choose-options-price'
        );
        const summaryTitle = document.getElementById(
          'mini-cart-choose-options-title'
        );
        const summaryImage = document.getElementById(
          'mini-cart-choose-options-image'
        );
        const contentTitle = container.querySelector('.product-title');
        const variantSelect = container.querySelector('.x-variants-data-js');
        const variantUpdateEl = container.querySelector(
          '[id^="variant-update-"]'
        );

        if (!contentPrice || !summaryPrice) return;

        const syncSummaryTitle = () => {
          if (!summaryTitle) return;

          const colorLegend = container.querySelector(
            'fieldset[data-swatch="true"] .option-selected-value span'
          );

          if (colorLegend && this.miniCartModalBaseTitle) {
            summaryTitle.textContent = `${this.miniCartModalBaseTitle} - ${colorLegend.textContent.trim()}`;
            return;
          }

          if (contentTitle) {
            summaryTitle.textContent = contentTitle.textContent.trim();
          }
        };

        const syncSummary = () => {
          summaryPrice.innerHTML = contentPrice.innerHTML;
          syncSummaryTitle();
        };

        syncSummary();
        this.miniCartPriceObserver = new MutationObserver(syncSummary);
        this.miniCartPriceObserver.observe(contentPrice, {
          childList: true,
          subtree: true,
          characterData: true,
        });

        if (contentTitle) {
          this.miniCartPriceObserver.observe(contentTitle, {
            childList: true,
            subtree: true,
            characterData: true,
          });
        }

        container
          .querySelectorAll(
            'fieldset[data-swatch="true"] .option-selected-value'
          )
          .forEach((legend) => {
            this.miniCartPriceObserver.observe(legend, {
              childList: true,
              subtree: true,
              characterData: true,
            });
          });

        if (variantSelect && variantUpdateEl) {
          const sectionId = variantUpdateEl.id.replace('variant-update-', '');
          const productUrl =
            variantSelect.dataset.url || this.miniCartProductBaseUrl;
          const eventName = `eurus:product-card-variant-select:updated:${sectionId}:${productUrl}`;

          const handler = (event) => {
            const html = event.detail?.html;
            const currentVariant = event.detail?.currentVariant;

            if (html && summaryImage) {
              const variantImageEl = html.getElementById('x-variant-image');
              if (variantImageEl?.dataset?.imageUrl) {
                summaryImage.src = variantImageEl.dataset.imageUrl;
                if (summaryTitle) {
                  summaryImage.alt = summaryTitle.textContent.trim();
                }
              }
            }

            if (currentVariant?.id) {
              this.updateMiniCartSummaryLinks(
                this.miniCartProductBaseUrl,
                currentVariant.id
              );
            }

            syncSummaryTitle();
            this.initMiniCartPaymentButtons();
          };

          document.addEventListener(eventName, handler);
          this.miniCartVariantUpdateHandler = { eventName, handler };
        }
      },
      async loadMiniCartChooseOption(url) {
        const urlProduct = this.buildChooseOptionUrl(url);
        const destinationElm = document.getElementById(
          'mini-cart-choose-options-content'
        );

        if (!destinationElm) return;

        this.loadingMiniCartChooseOption = true;

        try {
          if (this.loadedMiniCartChooseOptions[urlProduct]) {
            destinationElm.innerHTML =
              this.loadedMiniCartChooseOptions[urlProduct];
            this.prepareMiniCartChooseOptionContent(destinationElm);
            return;
          }

          const response = await fetch(urlProduct);
          const content = await response.text();
          const parser = new DOMParser();
          const parsedContent = parser
            .parseFromString(content, 'text/html')
            .getElementById('choose-options-content')?.innerHTML;

          if (parsedContent) {
            destinationElm.innerHTML = parsedContent;
            this.loadedMiniCartChooseOptions[urlProduct] = parsedContent;
            this.prepareMiniCartChooseOptionContent(destinationElm);
          }
        } catch (error) {
          console.log(error);
        } finally {
          this.loadingMiniCartChooseOption = false;
        }
      },
      openMiniCartChooseOption() {
        this.showMiniCartChooseOption = true;
        Alpine.store('xPopup').open = true;
      },
      closeMiniCartChooseOption() {
        this.showMiniCartChooseOption = false;
        if (this.miniCartPriceObserver) {
          this.miniCartPriceObserver.disconnect();
          this.miniCartPriceObserver = null;
        }
        if (this.miniCartVariantUpdateHandler) {
          document.removeEventListener(
            this.miniCartVariantUpdateHandler.eventName,
            this.miniCartVariantUpdateHandler.handler
          );
          this.miniCartVariantUpdateHandler = null;
        }
        if (!this.show && !Alpine.store('xMiniCart').open) {
          Alpine.store('xPopup').close();
        }
      },
      async openMiniCartProductModal(url, el) {
        this.setMiniCartChooseOptionSummary(el);
        await this.loadMiniCartChooseOption(url);
        this.openMiniCartChooseOption();
      },
      showBtn(enable, showATCButton, textBtn) {
        this.enabled = enable;
        this.buttonLabel = textBtn;
        this.show_atc_button = showATCButton;
      },
      load(url, el, optionId) {
        this.loading = true;

        requestAnimationFrame(() => {
          setTimeout(() => {
            if (this.buttonQuickView == '') {
              this.buttonQuickView = el;
            }
            let variant = document.getElementById(
              'current-variant-' + optionId
            )?.innerText;
            let productUrl = variant
              ? `${url}?variant=${variant}&section_id=${this.sectionId}`
              : `${url}?section_id=${this.sectionId}`;
            productUrl = productUrl.replace(/\s+/g, '');

            if (this.cachedResults[productUrl]) {
              document.getElementById('quickview-product-content').innerHTML =
                this.cachedResults[productUrl];
              this.loading = false;
              return true;
            }

            if (this.cachedfetch[productUrl]) {
              return true;
            }

            this.cachedfetch[productUrl] = true;
            fetch(productUrl)
              .then((reponse) => {
                return reponse.text();
              })
              .then((response) => {
                const parser = new DOMParser();
                const content = parser
                  .parseFromString(response, 'text/html')
                  .getElementById('quickview-product-content').innerHTML;
                document.getElementById('quickview-product-content').innerHTML =
                  content;
                this.cachedResults[productUrl] = content;
              })
              .finally(() => {
                this.loading = false;
                this.cachedfetch[productUrl] = false;
              });

            return true;
          }, 0);
        });
      },
      async loadChooseOptions(url, el, optionId, index) {
        setTimeout(async () => {
          let urlProduct = this.buildChooseOptionUrl(url, index);

          let destinationElm = document
            .getElementById('choose-options-' + optionId)
            ?.querySelector('.choose-options');
          let destinationElmMobile = document.getElementById(
            'choose-options-mobile'
          );
          let loadingEl = document
            .getElementById('choose-options-' + optionId)
            ?.querySelector('.icon-loading');

          if (this.loadedChooseOptions[urlProduct]) {
            if (window.innerWidth > 767) {
              if (
                !el
                  .closest('.card-product')
                  .querySelector('#choose-options-' + optionId)
                  ?.querySelector('.choose-options-content')
              ) {
                destinationElm &&
                  (destinationElm.innerHTML =
                    this.loadedChooseOptions[urlProduct]);
                destinationElmMobile && (destinationElmMobile.innerHTML = '');
              }
              if (destinationElm) {
                if (destinationElm.querySelector('.add_to_cart_button')) {
                  destinationElm.querySelector(
                    '.add_to_cart_button'
                  ).style.display = 'block';
                }
                if (destinationElm.querySelector('.label-btn-quickview')) {
                  destinationElm.querySelector(
                    '.label-btn-quickview'
                  ).style.display = 'none';
                }
              }
            } else {
              if (
                !el
                  .closest('.card-product')
                  .querySelector('#choose-options-mobile')
              ) {
                destinationElmMobile &&
                  (destinationElmMobile.innerHTML =
                    this.loadedChooseOptions[urlProduct]);
                destinationElm && (destinationElm.innerHTML = '');
              }
              if (destinationElmMobile) {
                if (destinationElmMobile.querySelector('.add_to_cart_button')) {
                  destinationElmMobile.querySelector(
                    '.add_to_cart_button'
                  ).style.display = 'block';
                }
                if (
                  destinationElmMobile.querySelector('.label-btn-quickview')
                ) {
                  destinationElmMobile.querySelector(
                    '.label-btn-quickview'
                  ).style.display = 'none';
                }
              }
            }
            return true;
          }

          try {
            if (loadingEl) {
              loadingEl.classList.remove('hidden');
            }
            this.loadingChooseOption = true;
            if (!this.loadingUrls.includes(urlProduct)) {
              this.loadingUrls.push(urlProduct);
              await fetch(urlProduct)
                .then((response) => response.text())
                .then((content) => {
                  const parser = new DOMParser();
                  const parsedContent = parser
                    .parseFromString(content, 'text/html')
                    .getElementById('choose-options-content')?.innerHTML;

                  if (parsedContent) {
                    if (window.innerWidth > 767) {
                      destinationElmMobile &&
                        (destinationElmMobile.innerHTML = '');
                      destinationElm &&
                        (destinationElm.innerHTML = parsedContent);
                    } else {
                      destinationElmMobile &&
                        (destinationElmMobile.innerHTML = parsedContent);
                      destinationElm && (destinationElm.innerHTML = '');
                    }
                    this.loadedChooseOptions[urlProduct] = parsedContent;
                  }
                  if (loadingEl) {
                    loadingEl.classList.add('hidden');
                  }
                })
                .finally(() => {
                  const index = this.loadingUrls.indexOf(urlProduct);
                  if (index !== -1) this.loadingUrls.splice(index, 1);
                  if (window.innerWidth > 767) {
                    if (destinationElm) {
                      if (destinationElm.querySelector('.add_to_cart_button')) {
                        destinationElm.querySelector(
                          '.add_to_cart_button'
                        ).style.display = 'block';
                      }
                      if (
                        destinationElm.querySelector('.label-btn-quickview')
                      ) {
                        destinationElm.querySelector(
                          '.label-btn-quickview'
                        ).style.display = 'none';
                      }
                    }
                  } else {
                    if (destinationElmMobile) {
                      if (
                        destinationElmMobile.querySelector(
                          '.add_to_cart_button'
                        )
                      ) {
                        destinationElmMobile.querySelector(
                          '.add_to_cart_button'
                        ).style.display = 'block';
                      }
                      if (
                        destinationElmMobile.querySelector(
                          '.label-btn-quickview'
                        )
                      ) {
                        destinationElmMobile.querySelector(
                          '.label-btn-quickview'
                        ).style.display = 'none';
                      }
                    }
                  }
                });
            }
            this.loadingChooseOption = false;
          } catch (error) {
            console.log(error);
          }
        }, 0);
      },
      open(isMiniCart = false) {
        this.show = true;
        this.isMiniCart = isMiniCart;
        Alpine.store('xPopup').open = true;
      },
      close() {
        this.show = false;
        this.buttonQuickView = '';
        if (!Alpine.store('xMiniCart').open) {
          Alpine.store('xPopup').close();
        }
      },
      focusQuickView(quickView, btnClose) {
        if (!this.selected) {
          Alpine.store('xFocusElement').trapFocus(quickView, btnClose);
        }
      },
      removeFocusQuickView() {
        if (!this.selected) {
          const elementActive = document.getElementById('button_quickview');
          Alpine.store('xFocusElement').removeTrapFocus(elementActive);
        }
      },
      closePopupMobile() {
        this.openPopupMobile = false;
      },
      showChooseOption(id, el) {
        this.openPopupMobile = true;
        const product = el.closest('.card-product');
        const addToCartBtn = product
          .querySelector('.choose-options')
          ?.querySelector('.add_to_cart_button');
        const iconAddToCartBtn = product
          .querySelector('.choose-options')
          ?.querySelector('.label-btn-quickview');
        const addToCartBtnMobile = document
          .querySelector('.choose-options-mobile')
          ?.querySelector('.add_to_cart_button');
        const iconAddToCartBtnMobile = document
          .querySelector('.choose-options-mobile')
          ?.querySelector('.label-btn-quickview');

        if (addToCartBtn && iconAddToCartBtn && window.innerWidth > 767) {
          addToCartBtn.style.display = 'block';
          iconAddToCartBtn.style.display = 'none';
        } else if (addToCartBtnMobile && iconAddToCartBtnMobile) {
          addToCartBtnMobile.style.display = 'block';
          iconAddToCartBtnMobile.style.display = 'none';
        }
      },
      clickInsideQuickView(evt, $el) {
        if (this.isMiniCart) {
          evt.stopPropagation();
          this.show = false;
          Alpine.store('xPopup').close();
        }
      },
      clickInsideContentQuickView(evt) {
        evt.stopPropagation();
      },
    });
  });
});
